export interface IFitCcWorkbookTable 
{
    columns: any[]; 
    data: any[];
}